// Lib
import { percentFormat } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const avgEngagementRateHistoryConfig = {
    title: 'chart.instagram.avg_engagement_rate_history',
    margin: { left: -10, right: 25 },
    name: {
        date: 'date',
        estimated: 'estimated_data',
        value: 'chart.instagram.avg_engagement_rate_history_name'
    },
    disableGraphData: ['count_posts'],
    id: 'average_engagement_rate_history',
    color: {
        value: 'green',
        estimated: 'green',
        unavailable: 'gray'
    },
    legendTypes: {
        value: 'line',
        unavailable: 'square'
    },
    valueFormat: { ...percentFormat, maximumFractionDigits: 4 },
    tooltip: 'chart.instagram.avg_engagement_rate_history_tooltip',
    size: SIZE_50,
    type: 'chart',
    noDataToken: 'chart.instagram.no_data_history_period',
    element: LineChart
};
